<template>
  <div class="issues-summary-card-container" @click="onClick">
    <div class="issues-summary-card" :style="cardStyle">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: ['onClick', 'cardStyle'],
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';
.issues-summary-card-container {
  margin: $spacer;
}
.issues-summary-card {
  position: relative;
  padding: $spacer * 1.5;
  box-shadow: 5px 5px 10px rgba(0, 0, 0, 0.5);
  border-radius: 5px;
}

@media (max-width: 575.98px) {
  .issues-summary-card-container {
    margin: 0;
  }
}
</style>
